<template>
  <div class="func">
    <div class="func1">
      <p class="func_title">方法1：點擊按鈕，快速分享至您的FB主頁</p>
      <div class="func_btn" @click="nowshare"></div>
    </div>
    <div class="func2">
      <p class="func_title">
        方法2：複製專屬連結，自行通過通訊軟體發送给您的朋友
      </p>
      <div class="func_inputbox">
        <input type="text" :value="value" class="func_input" ref="code" />
        <img
          src="../assets/images/nCopy.png"
          alt=""
          class="func_copy"
          @click="copy"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { share } from "@/js/api";
export default {
  name: "invite_alter",
  props: ["allCode"],
  data() {
    return {
      codePage: "",
      value: "",
    };
  },
  mounted() {
    this.value =
      location.origin + location.pathname + "?f=" + this.allCode.inviteCode;
  },
  methods: {
    copy() {
      let input = document.createElement("input");
      let content = this.$refs.code._value;
      input.value = content;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.$bus.$emit("tips", "複製成功");
      //   this.openTips("複製成功");
      //   document.body.removeChild("input");
    },
    nowshare() {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: 553154342524745,
        status: true,
        xfbml: true,
        version: "v2.9",
      });
      // eslint-disable-next-line no-undef
      var c = this.$util.getChannel(this);
      var p = "";
      if (c && c.length > 0) {
        p = c + "?f=" + this.allCode.inviteCode;
      } else {
        p = "?f=" + this.allCode.inviteCode;
      }
      console.log(p, "==========");
      FB.ui(
        {
          display: "popup",
          method: "share",
          href: `https://pre.xiaoma.com.tw/dxz/${p}`,
        },
         (response) => {
          console.log(response);
          if (response && !response.error_message) {
            let data = this.$util.getToken().token;
            share(data).then((res) => {
              this.codePage = res.data.code; //邀请人后的礼包码
              // console.log(this.shareUrl);
              this.$xmlog.inviteFriend();
            });
            // that.$bus.$emit("tips", "Posting completed.");
          }
          // else {
          //   that.$bus.$emit("tips", "Error while posting.");
          // }
        }
      );
    },
    
    // shareUrl() {
    //   return (
    //     location.origin + location.pathname + "?f=" + this.allCode.inviteCode
    //   );
    // },
  },
};
</script>

<style lang="less" scoped>
.func {
  text-align: left;
  .func1 {
    .func_title {
      color: #000612;
      font-size: 0.24rem;
      font-weight: 600;
    }
    .func_btn {
      height: 1.2rem;
      width: 4.16rem;
      background: url("../assets/images/nowshare.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .func2 {
    margin-top: 0.2rem;
    .func_title {
      color: #000612;
      font-size: 0.24rem;
      font-weight: 600;
    }
    .func_inputbox {
      display: flex;
      align-items: center;
      width: 100%;
      margin-top: 0.2rem;
      .func_input {
        background: url("../assets/images/ninput_bg.png");
        border: none;
        background-size: 102% 100%;
        padding: 0.1rem 0.1rem;
        border-radius: 0;
        height: 0.4rem;
        width: 100%;
        font-size: 0.25rem;
      }
      .func_copy {
        height: 0.6rem;
        cursor: pointer;
        z-index: 10;
      }
    }
  }
}
</style>